import backIcon from "../../assets/images/icons/backIcon.png";
import threeDIcon from "../../assets/images/logos/3D Objetc.png";
import photoIcon from "../../assets/images/logos/Image-.png";
import videoIcon from "../../assets/images/logos/Video-.png";
import three60Icon from "../../assets/images/logos/360.png";
import React, { useEffect, useState } from 'react';
import ImageModal from "../../components/imageModal/imageModal";
import { api } from '../../api/management';
import Model3DModal from "../../components/model3DModal/model3DModal";
import MapModelf from "../../assets/models/Flor.glb"


const Gallery = ({ setShowGallery }) => {
    const [showImageModal, setShowImageModal] = useState(false);
    const [showModel3DModal, setShowModel3DModal] = useState(false);
    const [imageSelected, setImageSelected] = useState("");
    const [mobile, setMobile] = useState(false);
    const [hotspotDetail, setHotspotDetail] = useState({});
    const [hotspotMultimedia, sethotspotMultimedia] = useState({});

    useEffect(() => {
        if(!window.localStorage.getItem("hotspotId")){
            window.location.href = window.location.origin
        }
        api.getHotspot( window.localStorage.getItem("hotspotId")).then(response => {
            setHotspotDetail({...response.hotspot});
            sethotspotMultimedia([...response.multimedia]);
            setImageSelected({
                imageName: response.multimedia[0].name,
                imageSrc: response.multimedia[0].src,
                imageType: response.multimedia[0].type
            });
        });
    }, []);

    const onClickImage = (name, src, type) => {
        setImageSelected({
            imageName: name,
            imageSrc: src,
            imageType: type
        });
        if(type !== "threeD"){
            setShowImageModal(true);
            setShowModel3DModal(false);
        }else{
            setShowModel3DModal(true);
            setShowImageModal(false);
        }
    }

    let typeIcons = {
        img: photoIcon,
        video: videoIcon,
        threeD: threeDIcon,
        "360": three60Icon,
    };

    const selectedType = (type) =>  typeIcons[type];

    const mobileCheck = () => {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }

    useEffect(() => {
        const state = mobileCheck();
        setMobile(state);
        if(!state){
            setShowImageModal(true);
        }
    },[])


    if(!hotspotDetail.name){
        return (<div></div>);
      }
    else{
        return (
            <>
                {mobile ?
                        <GalleryMobile 
                            setShowGallery={setShowGallery} 
                            hotspotDetail = {hotspotDetail}
                            hotspotMultimedia = {hotspotMultimedia}
                            selectedType = {selectedType}
                            imageSelected= {imageSelected}
                            showImageModal = {showImageModal}
                            showModel3DModal = {showModel3DModal}
                            setShowImageModal = {setShowImageModal}
                            setShowModel3DModal={setShowModel3DModal}
                            onClickImage = {onClickImage}
                        />
                    :
                        <GalleryDesktop 
                            setShowGallery={setShowGallery} 
                            hotspotDetail = {hotspotDetail}
                            hotspotMultimedia = {hotspotMultimedia}
                            selectedType = {selectedType}
                            imageSelected= {imageSelected}
                            showImageModal = {showImageModal}
                            showModel3DModal = {showModel3DModal}
                            setShowImageModal = {setShowImageModal}
                            setShowModel3DModal={setShowModel3DModal}
                            onClickImage = {onClickImage}
                        />
                }
            </>
    );
    }
};

const GalleryMobile = ({ setShowGallery, hotspotDetail, hotspotMultimedia, selectedType, imageSelected, showImageModal, showModel3DModal, setShowImageModal, setShowModel3DModal, onClickImage}) => {
    return (
        <>
            <div className="bg-white fixed top-0 left-0 right-0 z-40 w-full lg:inset-0 h-screen lg:h-full lg:hidden">
                <nav className="border-gray-200 rounded">
                    <div className="container flex flex-wrap items-center justify-between mx-auto">
                        <div className="w-full p-3 flex items-center shadow-md">
                            <div onClick={() => {setShowGallery(false)}}
                                className="cursor-pointer text-xl leading-none pr-3 py-1 border border-solid border-transparent block outline-none focus:outline-none" 
                            >
                            <img className="h-6" src={ backIcon } alt="Back button"/>
                            </div>
                            <span className="self-center text-xl font-bold whitespace-nowrap">{hotspotDetail.name}</span>
                        </div>
                    </div>
                </nav>
                <section className="h-full overflow-y-auto overflow-x-hidden text-gray-700 padding-bottom">
                    <div className="container px-5 py-2 mx-auto lg:pt-12 lg:px-32 lg:pr-0">
                        <div className="-m-1 lg:-m-2">
                            {hotspotMultimedia && hotspotMultimedia.map((img, i) =>
                                <div key={i} className="flex flex-wrap"  onClick={() => onClickImage(img.name, img.src, img.type)}>
                                    <div className="w-full p-1 lg:p-2 relative">
                                        <button type="button" className="z-10 m-4 rounded-full bg-white absolute bottom-0 right-0 hover:bg-gray-200 text-sm inline-flex items-center">
                                            <img className="h-8" src={selectedType(img.type)} alt={img.type+" icon"}/>
                                        </button>
                                        {img.type === "img" && <img alt={img.name} className="block object-cover object-center w-full h-full"
                                        src={img.src}/>}
                                    
                                        {
                                        img.type === "video" && 
                                        <video alt={img.name} className="block object-cover object-center w-full h-full" >
                                            <source src={img.src} type="video/mp4"></source>
                                            <source src={img.src} type="video/ogg"></source>
                                        </video>
                                        }
                                        { 
                                        img.type === "threeD" && 
                                        <model-viewer skybox-image={"sky.hdr"} alt={img.name} src={img.src} auto-rotate shadow-intensity="3" className={{ "width": "100%",
                                            "height": "30rem"}}>
                                            <div className="progress-bar hide" slot="progress-bar">
                                                <div className="update-bar"></div>
                                            </div>
                                            <button slot="ar-button" id="ar-button">
                                                View in your space
                                            </button>
                                        </model-viewer>
                                        }

                                        {img.type === "360" && <img alt={img.name} className="block object-cover object-center w-full h-full"
                                                                    src={img.src}/>}
                                    </div>
                                </div>                   
                            )}
                        </div>
                    </div>
                </section>
            </div>
            {showImageModal &&
                <ImageModal
                    name={imageSelected.imageName && imageSelected.imageName}
                    src = {imageSelected.imageSrc && imageSelected.imageSrc}
                    type = {imageSelected.imageType && imageSelected.imageType}
                    setShowImageModal = {setShowImageModal}
                />}
            {showModel3DModal && 
                <Model3DModal
                    name={imageSelected.imageName && imageSelected.imageName}
                    src = {imageSelected.imageSrc && imageSelected.imageSrc}
                    type = {imageSelected.imageType && imageSelected.imageType}
                    setShowModel3DModal = {setShowModel3DModal}
                />}
        </>
    )
}


const GalleryDesktop = ({  setShowGallery, hotspotDetail, hotspotMultimedia, selectedType, imageSelected, showImageModal, showModel3DModal, setShowImageModal, setShowModel3DModal, onClickImage }) => {
    return (
        <>
            <div className="bg-white fixed top-0 left-0 right-0 z-40 w-full lg:inset-0 h-full lg:h-full sm:hidden lg:block">
                <nav className="border-gray-200 rounded">
                    <div className="flex flex-wrap items-center justify-between mx-auto">
                        <div className="w-full p-3 flex items-center shadow-md">
                            <div href="/" onClick={() => {setShowGallery(false)}}
                                className="cursor-pointer text-xl leading-none pr-3 py-1 border border-solid border-transparent block outline-none focus:outline-none" 
                            >
                            <img className="h-6" src={ backIcon } alt="Icon News"/>
                            </div>
                            <span className="self-center text-xl font-bold whitespace-nowrap">{hotspotDetail.name}</span>
                        </div>
                    </div>
                </nav>
                <div className="flex lg:flex-row lg:mt-2 mb-8 lg:h-full">
                    <div className="overflow-y-scroll scrollbar overflow-x-hidden text-gray-700 h-5/6 lg:w-1/3">
                        <div className="container px-5 py-2 mx-auto">
                            <div className="-m-1 lg:-m-2">
                                {hotspotMultimedia && hotspotMultimedia.map((img, i) =>
                                    <div key={i} className="flex flex-wrap"  onClick={() => onClickImage(img.name, img.src, img.type)}>
                                        <div className="w-full p-1 lg:p-2 relative">
                                            <button type="button" className="m-4 rounded-full bg-white absolute bottom-0 right-0 hover:bg-gray-200 text-sm inline-flex items-center">
                                                <img className="h-8" src={selectedType(img.type)} alt="Icon News"/>
                                            </button>
                                            {img.type === "img" && <img alt={img.name} className="block object-cover object-center w-full h-full"
                                            src={img.src}/>}
                                        
                                            {
                                            img.type === "video" && 
                                            <video alt={img.name} className="block object-cover object-center w-full h-full" >
                                                <source src={img.src} type="video/mp4"></source>
                                                <source src={img.src} type="video/ogg"></source>
                                            </video>
                                            }
                                            { 
                                            img.type === "threeD" && 
                                            <model-viewer skybox-image={"sky.hdr"} alt={img.name} src={img.src} auto-rotate shadow-intensity="3" className={{ "width": "100%",
                                                "height": "30rem"}}>
                                                <div className="progress-bar hide" slot="progress-bar">
                                                    <div className="update-bar"></div>
                                                </div>
                                                <button slot="ar-button" id="ar-button">
                                                    View in your space
                                                </button>
                                            </model-viewer>
                                            }

                                            {img.type === "360" && <img alt={img.name} className="block object-cover object-center w-full h-full"
                                                                        src={img.src}/>}
                                        </div>
                                    </div>                   
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="hidden lg:block lg:w-full h-5/6">
                        {showImageModal && 
                            <ImageModal
                                name={imageSelected.imageName && imageSelected.imageName}
                                src = {imageSelected.imageSrc && imageSelected.imageSrc}
                                type = {imageSelected.imageType && imageSelected.imageType}
                                setShowImageModal = {setShowImageModal}
                            />
                        }
                        {showModel3DModal && 
                            <Model3DModal
                                name={imageSelected.imageName && imageSelected.imageName}
                                src = {imageSelected.imageSrc && imageSelected.imageSrc}
                                type = {imageSelected.imageType && imageSelected.imageType}
                                setShowModel3DModal = {setShowModel3DModal}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

  export default Gallery;